import { Outlet, createFileRoute } from '@tanstack/react-router'

import { ProductGuaranteesPageSkeleton } from '#/modules/guarantee/front-office/product-guarantees-page/product-guarantees-page-skeleton.tsx'
import { ProductGuaranteesPage } from '#/modules/guarantee/front-office/product-guarantees-page/product-guarantees-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/product-guarantees/$subscriptionId/$productName')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      context.trpc.contracts.getMyContract.queryOptions(
        {
          subscriptionId: params.subscriptionId,
          includeTerminatedBeforeOneMonth: false,
        },
        frontOfficeQueryOptions,
      ),
    ),
  pendingComponent: ProductGuaranteesPageSkeleton,
  pendingMs: 150,
  component: ProductGuaranteesRoute,
})

// The guarantee detail is a child route rendering a side panel over the list, so both mount as
// siblings: they share the `getMyContract` cache entry warmed by the loader above, with no provider.
function ProductGuaranteesRoute() {
  const { subscriptionId, productName } = Route.useParams()
  return (
    <>
      <ProductGuaranteesPage subscriptionId={subscriptionId} productName={productName} />
      <Outlet />
    </>
  )
}
